import { Store } from 'rxjs-observable-store';
import { TrackShuttleCounter } from './models/track_counter';
import * as i0 from "@angular/core";
export class TrackSelectionService extends Store {
    constructor() {
        super(new TrackShuttleCounter());
    }
}
TrackSelectionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TrackSelectionService_Factory() { return new TrackSelectionService(); }, token: TrackSelectionService, providedIn: "root" });
